import React, { useState, useEffect } from 'react';
import { X, Undo2 } from 'lucide-react';

const SkippableInput = ({
  value,
  onChange,
  onBlur,
  onFocus,
  rows = 4,
  className,
  field,
  sectionId,
  index,
  isSkipped,
  onSkipChange,
  validationError,
  type = "textarea" // new prop for input type
}) => {
  const [isFieldSkipped, setIsFieldSkipped] = useState(isSkipped);

  useEffect(() => {
    setIsFieldSkipped(isSkipped);
  }, [isSkipped]);

  const handleSkipClick = async () => {
    const newSkipValue = !isFieldSkipped;
    setIsFieldSkipped(newSkipValue);
    await onSkipChange(newSkipValue);
  };

  if (isFieldSkipped) {
    return (
      <div className="space-y-3 transition-all duration-300 ease-in-out">
        <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200 shadow-sm">
          <p className="text-gray-500 italic flex items-center gap-2">
            This question has been skipped
          </p>
          <button
            type="button"
            onClick={handleSkipClick}
            className="inline-flex items-center gap-2 px-4 py-1 text-sm font-medium text-[#F16745] bg-white border border-[#F16745] rounded-md hover:bg-[#F1EBDB] focus:outline-none focus:ring-2 focus:ring-[#F16745] focus:ring-offset-2 transition-all duration-200 ease-in-out shadow-sm hover:shadow-md"
          >
            <Undo2 size={16} />
            Reopen Question
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-3 transition-all duration-300 ease-in-out">
      <div className="relative">
        {type === "textarea" ? (
          <textarea
            rows={rows}
            className={`w-full px-4 py-3 text-gray-700 bg-white border rounded-lg focus:ring-2 focus:ring-[#F16745] focus:border-[#F16745] outline-none transition-all duration-200 ease-in-out ${
              validationError ? 'border-red-500' : 'border-gray-300'
            } ${className}`}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            onFocus={onFocus}
          />
        ) : (
          <input
            type={type}
            className={`w-full px-4 py-3 text-gray-700 bg-white border rounded-lg focus:ring-2 focus:ring-[#F16745] focus:border-[#F16745] outline-none transition-all duration-200 ease-in-out ${
              validationError ? 'border-red-500' : 'border-gray-300'
            } ${className}`}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            onFocus={onFocus}
          />
        )}
      </div>
      <div className="flex flex-col space-y-3">
        {validationError && (
          <p className="text-sm text-red-600 bg-red-50 px-3 py-2 rounded-md">
            {validationError}
          </p>
        )}
        <div className="flex justify-end">
          <button
            type="button"
            onClick={handleSkipClick}
            className="inline-flex items-center gap-2 px-4 py-1.5 text-sm font-medium text-[#F16745] bg-white border border-[#F16745] rounded-full hover:bg-[#F1EBDB] focus:outline-none focus:ring-2 focus:ring-[#F16745] focus:ring-offset-2 transition-all duration-200 ease-in-out shadow-sm hover:shadow-md whitespace-nowrap"
          >
            <X size={16} />
            Skip question
          </button>
        </div>
      </div>
    </div>
  );
};

export default SkippableInput; 